/**
 * @module  public/js/pages/index.js
 * @summary Handles login form submission, authentication and post-login redirect.
 *
 * @description
 * Listens for the login form’s submit event to authenticate the user via
 * LoginService and persist their connection status before navigation.
 *
 * ## Key Features
 * – Authenticates email / password credentials with Firebase
 * – Persists connection status through LoginService for analytics
 * – Provides user-friendly error messaging and rate-limit handling
 *
 * ## Public API
 * – (not documented)
 *
 * ## Dependencies
 * { LoginService }
 *
 * @author   Auto-Generated
 * @version  1.0.0
 * @since    2025-04-28
 */

import LoginService from '../services/loginService.js';
import { authReady } from '../core/firebase-service.js';
import AuthTelemetry from '../core/auth/AuthTelemetry.js';
import { NetHealthService as NetHealthServiceController } from '../core/net/NetHealthService.js';
import createLoginController from './loginController.js';
import { loadLoginAuthConfig } from './loginAuthConfig.js';

const netHealthService = new NetHealthServiceController();
const authTelemetry = new AuthTelemetry({
  netHealthProvider: () =>
    typeof netHealthService.getStatus === 'function'
      ? netHealthService.getStatus()
      : null,
});

const controller = createLoginController({
  loginService: LoginService,
  authReady,
  authTelemetry,
  netHealthService,
  document,
  window,
  logger: console,
});

controller.renderPendingLoginIssue();

// Grabbing the form
const loginForm = document.getElementById('loginForm');
const togglePasswordBtn = document.getElementById('togglePassword');
const googleSignInButton = document.getElementById('googleSignInButton');
const microsoftSignInButton = document.getElementById('microsoftSignInButton');
if (togglePasswordBtn) {
  togglePasswordBtn.addEventListener('click', () => {
    const pw = document.getElementById('password');
    if (!pw) {
      return;
    }

    const isHidden = pw.getAttribute('type') === 'password';
    pw.setAttribute('type', isHidden ? 'text' : 'password');
    togglePasswordBtn.textContent = isHidden ? 'Hide' : 'Show';
    togglePasswordBtn.setAttribute(
      'aria-label',
      `${isHidden ? 'Hide' : 'Show'} password`
    );
  });
}
if (loginForm) {
  loginForm.addEventListener('submit', (e) => {
    void controller.handleSubmit(e);
  });
}
if (googleSignInButton) {
  googleSignInButton.addEventListener('click', (e) => {
    void controller.handleGoogleSignIn(e);
  });
}
if (microsoftSignInButton) {
  microsoftSignInButton.addEventListener('click', (e) => {
    void controller.handleMicrosoftSignIn(e);
  });
}

controller.applyAuthProviderConfig({});

loadLoginAuthConfig()
  .then((authConfig) => {
    controller.applyAuthProviderConfig(authConfig);
  })
  .catch((error) => {
    console.warn('[login] auth provider config unavailable', error);
    controller.applyAuthProviderConfig({});
  });
